import React from 'react';
import Banner from './Banner';
import Services from './Services';
import WhyChoose from './WhyChoose';
import Counter from './Counter';
import Process from './Process'
import GoogleMap from './GoogleMap';


const HomeTwoMain = () => {
	return (
		<>
			<Banner />
			<Services />
			<WhyChoose />
			<Counter />
			<Process />
			<GoogleMap />
		</>
	);
}

export default HomeTwoMain;
